import { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import { TypePage } from './_models/TypePage';
import mockPage from './_utils/mockPage';
import Header from './Header';
import MobileHeader from './MobileHeader';
import ContentHeader from './ContentHeader';
import Backdrop from '../components/Backdrop';
import useStyles from './styles';

interface Props {
  page: TypePage;
  innerPage?: boolean;
  hideBackButton?: boolean;
  backLink?: string;
  loading?: boolean;
}

const Layout: React.FC<Props> = (props) => {
  const {
    page,
    innerPage = false,
    hideBackButton = false,
    backLink,
    loading,
    children,
  } = props;
  const classes = useStyles();

  const [content] = useState(mockPage(page));

  return (
    <Grid container className={classes.container}>
      {loading && <Backdrop loading={loading} />}
      <Header
        innerPage={innerPage}
        backLink={backLink}
        hideBackButton={hideBackButton}
      />
      <Hidden smUp>
        <MobileHeader content={content} />
      </Hidden>
      <Grid
        container
        item
        xs={12}
        md={10}
        xl={8}
        component="main"
        className={classes.contentContainer}
      >
        <Hidden only="xs">
          <ContentHeader
            content={content}
            outsideBackLink={backLink}
            hideBackButton={hideBackButton}
          />
        </Hidden>
        {children}
      </Grid>
    </Grid>
  );
};

export default Layout;
